<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { AttributeDeleterDialogViewModel } from "@Alternatives/Attributes/Components/AttributeDeleterDialog";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class AttributeDeleterDialog extends Vue
    {
        get vm(): AttributeDeleterDialogViewModel { return this.$props.viewModel as AttributeDeleterDialogViewModel; }

        get opened() : boolean { return this.vm.opened; }
        get initialized(): boolean { return this.vm.rm != null;  }
        get attributeName(): string { return this.vm.attributeName; }
        get hasDependants(): boolean { return this.vm.rm?.HasDependants ?? true; }
        get dependenciesCount(): number | null { return this.vm.rm?.Count ?? null; }


        emitDeleteAttribute()
        {
            this.$emit("delete-attribute", this.vm.attributeId);
        }

        emitShowDependencies()
        {
            this.$emit('show-dependencies', this.vm.attributeId)
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header" :class="{'bg-danger': !hasDependants }">
                        <h5 class="modal-title">Delete attribute: {{attributeName}}</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <h4 v-if="!initialized">
                            <i class="fa fa-spinner fa-spin"></i> Checking dependencies...
                        </h4>

                        <div v-if="initialized && hasDependants">
                            <div class="alert alert-danger text-dark" role="alert">
                                <h5 class="alert-heading">Cannot delete this attribute</h5>
                                <p>The attribute '<strong>{{attributeName}}</strong>' is used in <strong>{{dependenciesCount}}</strong> places.
                                    To delete this attribute, first remove it from where it is used.</p>
                            </div>
                        </div>
                        <div v-if="initialized && !hasDependants">
                            <h4>Are you sure you want to delete this attribute?</h4>
                            <p>You are about to delete '<strong>{{attributeName}}</strong>'. This can't be undone.</p>
                        </div>

                    </div>

                    <div class="modal-footer">
                        <button v-if="initialized && hasDependants" type="button" class="btn btn-secondary" @click="emitShowDependencies">View dependencies</button>
                        <button v-if="initialized && !hasDependants" type="button" class="btn btn-danger" @click="emitDeleteAttribute">Delete</button>
                        <button type="button" class="btn btn-outline-secondary" @click="close">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>